class CartCount extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return
    if (!state.sections) return

    if (!('push-cart-count' in state.sections)) return

    const count = this.getCount(state.sections['push-cart-count'])
    this.textContent = count
    this.setAttribute('aria-hidden', count === '0')
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)

    return DOM.querySelector('#push-cart-count').textContent
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
